import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';

import { LoginService } from '../services/login.service';

@Injectable({
	providedIn: 'root'
})

export class MainGuard implements CanActivate {

	constructor(private loginService:LoginService){}

	canActivate(): Promise<boolean> | boolean {
		return this.loginService.validarUsuarioEstado();
	}
  
}
